import React from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import { useNavigate } from "react-router-dom";
import Joints from "./Joints";

function UpdateJoints() {
  const navigation = useNavigate();

  return (
    <AppContainer title="Installation Details">
      <div className="card custom-card main-content-body-profile">
        <div className="card-body tab-content h-100">
          <h4 className="card-title">Update pole Joint</h4>

          <Joints navi={navigation} />
        </div>
      </div>
    </AppContainer>
  );
}

export default UpdateJoints;
